export function detectBrowser() {
  if (isChrome()) {
    return "chrome";
  } else if (isFirefox()) {
    return "firefox";
  } else if (isEdge()) {
    return "edge";
  } else if (isOpera()) {
    return "opera";
  } else if (isSafari()) {
    return "safari";
  } else if (isIE()) {
    return "iE";
  } else {
    return "unknown";
  }
}

/**
 * Funções simplificadas para detecção do browser, modifique se achar necessário
 */
function isOpera() {
  return !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;
}

function isFirefox() {
  return typeof InstallTrigger !== "undefined";
}

function isSafari() {
  return navigator.userAgent.indexOf("Safari") > -1;
}

function isIE() {
  return /*@cc_on!@*/ false || !!document.documentMode;
}

function isEdge() {
  if (document.documentMode || /Edge/.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
}

function isChrome() {
  return /Google Inc/.test(navigator.vendor);
}

export function isExtensionInstalled() {
  if (
    typeof window.BryExtension !== "undefined" &&
    typeof window.BryExtension.listCertificates === "function"
  )
    return true;
  else return false;
}

export function validaCPF(cpf) {
    cpf = cpf.replace(/[^\d]+/g,'');

    if (cpf === "00000000000" ||
        cpf === "11111111111" ||
        cpf === "22222222222" ||
        cpf === "33333333333" ||
        cpf === "44444444444" ||
        cpf === "55555555555" ||
        cpf === "66666666666" ||
        cpf === "77777777777" ||
        cpf === "88888888888" ||
        cpf === "99999999999")
        return false;

    if (cpf === '') return false;
    if (cpf.length !== 11)
        return false;

    let soma;
    let resto;
    soma = 0;

    for (let i = 1; i <= 9; i++)
      soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);

    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) resto = 0;

    if (resto !== parseInt(cpf.substring(9, 10))) return false;

    soma = 0;
    for (let i = 1; i <= 10; i++)
      soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.substring(10, 11))) return false;
    return true;
}

export function validaCNPJ(cnpj) {
    if (cnpj == null) return false;
    cnpj = cnpj.replace(/[^\d]+/g,'');

    if (cnpj === '') return false;

    if (cnpj.length !== 14)
        return false;

    // Elimina CNPJs invalidos conhecidos
    if (cnpj === "00000000000000" ||
        cnpj === "11111111111111" ||
        cnpj === "22222222222222" ||
        cnpj === "33333333333333" ||
        cnpj === "44444444444444" ||
        cnpj === "55555555555555" ||
        cnpj === "66666666666666" ||
        cnpj === "77777777777777" ||
        cnpj === "88888888888888" ||
        cnpj === "99999999999999")
        return false;

    // Valida DVs
    let tamanho = cnpj.length - 2
    let numeros = cnpj.substring(0,tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;

    // 38.736.278/0001-02
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }

    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado !== parseInt(digitos.charAt(0))) {
        return false;
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0,tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
            pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado !== parseInt(digitos.charAt(1))) {
        return false;
    }

    return true;
}
